import services from '../../../services';
import { getIrcDetail, translateIrcDetail, deleteTranslate } from '../../../services/urlConfig';

export function getIrcDetailData(params = {}) {
  return services[getIrcDetail.type](getIrcDetail.url, params, { showLoading: true });
}

export function translateIrc(params = {}) {
  return services[translateIrcDetail.type](translateIrcDetail.url, params, {
    errorToast: true,
    showLoading: true,
  });
}
export function deleteTranslateIrc(params = {}) {
  return services[deleteTranslate.type](deleteTranslate.url, params, {
    errorToast: true,
    showLoading: true,
  });
}
